"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.udappProfile = void 0;
exports.udappProfile = {
    name: 'udapp',
    methods: ['createVMAccount', 'getAccounts', 'sendTransaction', 'getSettings', 'setEnvironmentMode'],
    events: ['newTransaction']
};
//# sourceMappingURL=profile.js.map